import moment from 'moment';
import { dateFormats } from './constants';

const getDisabledDateForPicker = (start, end) => {
  if (!start || !end) return false;
  return start.isAfter(end, 'day');
};

const compareDates = ({ date, compareDate, method, unit = 'minute' }) =>
  date[method]?.(compareDate, unit);

const shiftTime = ({
  time,
  amount,
  unit = 'minutes',
  inputFormat = 'HH:mm',
  outputFormat = 'HH:mm',
}) => moment(time, inputFormat).add(amount, unit).format(outputFormat);

const timeToMinutes = (time) => {
  const [hours, minutes] = time.split(':').map(Number);
  return hours * 60 + minutes;
};

const createPeriod = (from, to) =>
  from && to ? `${formatDate(from)} - ${formatDate(to)}` : undefined;

const dateToISO = (date) => date?.clone().format(dateFormats.ISO);

function formatDate(date, format = dateFormats.DMY) {
  const _format = typeof format === 'string' ? format : dateFormats.DMY;
  return moment(date).format(_format);
}

export {
  moment as dateTime,
  getDisabledDateForPicker,
  shiftTime,
  compareDates,
  timeToMinutes,
  createPeriod,
  dateToISO,
  formatDate,
};
